export default "__VITE_ASSET__DIommm_u__";